<div
  class="relative z-20 flex min-h-[35px] items-center justify-center border-b border-solid border-neutral-300 px-6 py-2"
  [class]="bannerConfig().containerClass"
>
  <div class="flex items-center justify-center gap-2">
    <dojo-icon [icon]="bannerConfig().icon" [size]="16" />
    <span class="text-center">{{ bannerMessage() }}</span>
  </div>
</div>
